<template>
    <ul class="listBelo">
        <li class="mt-2" v-for="spreads,key,index in indexData"  @click.prevent="$parent.loadChart3 = spreads.other.mn ; $parent.loadChart2 = spreads.other.isinid" :class="($parent.loadChart2 == spreads.other.isinid)?'active':''">
            <div class="flagIcon d-flex align-items-center">
                <span class="s1" v-if="spreads.other.isinid.substring(0,3) != 'USO'">
                    <img :src="'../../../../static/fxView/images/marketsummery/'+spreads.other.isinid.substring(0,3).toLowerCase()+'.svg'" :alt="spreads.other.isinid.substring(0,3).toLowerCase()">
                </span>
                <span class="circle_ico" v-else>{{spreads.other.isinid.charAt(0)}}</span>
                <span class="s2" v-if="spreads.other.isinid.substring(3,6) != 'USO'">
                    <img :src="'../../../../static/fxView/images/marketsummery/'+spreads.other.isinid.substring(3,6).toLowerCase()+'.svg'" :alt="spreads.other.isinid.substring(3,6).toLowerCase()">                    
                </span>
                <span class="s1" v-else>{{spreads.other.isinid.charAt(0)}}</span>
            </div>
            <p class="m-0">
                {{spreads.other.isinid}}
                <!-- <small>{{spreads.other.isinid.substring(0,3)}}</small> -->
            </p>
            <span class="valueMid" :class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</span>
            <span class="upLow">
                <span  :class="(spreads.B-spreads.other.closepx >= 0)?'green':'red'">
                    {{flotData(((spreads.B-spreads.other.closepx)/spreads.other.closepx)*100)}}%
                </span>
                <span :class="(((spreads.B-spreads.other.closepx)/spreads.other.closepx)*100 >= 0)?'green':'red'">
                    {{flotData(spreads.B-spreads.other.closepx)}}
                </span>
            </span>
        </li>
        <!-- <div class="loader homechartloader py-5"></div> -->
        <!-- <div class="loader homechartloader py-5" v-if="Object.keys(indexData).length == 0 && Object.keys(get_currencies).length == 0"></div> -->
        <div class="noRecordFound" v-if="Object.keys(indexData).length == 0 && Object.keys(get_currencies).length > 0"> 
            <img src="../../../../static/fxView/images/search.svg" alt="no record found">
            <p>{{$t('thereIsNoRecord')}}</p>
        </div>
        <!-- <div class="loader homechartloader" v-if="Object.keys(indexData).length == 0">Please wait loading..</div> -->
    </ul>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'

    import { Const } from '@/plugins/vue-provider-cache/const.mod'
    export default {
        name: 'Price-index',

        data() {
            return { }
        },
        methods:{
            flotData(value){
                try{
                    if(parseFloat(parseFloat(value).toFixed(2).replace(/[.,]00$/, ""))){
                        return parseFloat(value).toFixed(2).replace(/[.,]00$/, "")
                    }else{
                        return parseFloat(value).toFixed(3).replace(/[.,]000$/, "") || '0'
                    }
                }catch(e){
                    return value
                }
            }
        },
        computed: {
            indexData() {
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                  .iCache.getIndexList()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return {}
              }
            },
            get_currencies(){
                try {
                    this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                    return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                    .iCache.asKeysValueArrayAll()
                } catch (ex) {
                    return {}
                }
            }
        },
        created(){
            // console.log('price-index-section')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/price_index.vue